import { render, staticRenderFns } from "./productDemandRecommend.vue?vue&type=template&id=96245eec&scoped=true&"
import script from "./productDemandRecommend.vue?vue&type=script&lang=js&"
export * from "./productDemandRecommend.vue?vue&type=script&lang=js&"
import style0 from "./productDemandRecommend.vue?vue&type=style&index=0&id=96245eec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96245eec",
  null
  
)

export default component.exports